import React from "react";

class About extends React.Component {
  render() {
    return (
      <React.Fragment>
        {" "}
        <section id="about" className="add-padding bg-color2">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 scrollimation fade-right d1">
                <img
                  className="img-responsive polaroid"
                  src="assets/images/portrait.jpg"
                  alt=""
                />
              </div>

              <div className="col-sm-6 scrollimation fade-left d3">
                <h1 className="big-text">Shawn Douglas </h1>
                <hr />
                <p className="lead">
                  Professional hair stylist in Orange County, CA with 6 years of
                  expert experience in the latest trends and fashions.
                  <br />
                </p>
                <p>
                  Passionate about bringing beauty and style to any client
                  utilzing the latest styles of Men and Womens hair specializing
                  in
                </p>{" "}
                <br />{" "}
                <span className="text-main h3">
                  Hair Cuts | Colors | Extensions | Keratin Treatments
                </span>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default About;
